module.exports = __webpack_public_path__ + "img/arc-updates.fa82b3c3.svg";